<template>
  <section>
    <container class="container">
      <button-header class="title">Colonel’s Tips om KFC leftovers op te warmen</button-header>
      <cms-content>
        <ol>
          <li>Bewaar je leftovers in de koelkast bij 5⁰C of kouder.</li>
          <li>Verwarm je leftover in een voorverwarmde oven van 180 graden, voor zo’n 20 minuten.</li>
          <li>Zorg ervoor dat al je opgewarmde leftovers een minimum kerntemperatur van 65⁰C hebben.</li>
          <li>Enjoy!</li>
        </ol>
      </cms-content>
    </container>
  </section>
</template>
<script>
import Container from '../components/Container.vue';
import ButtonHeader from '../components/ButtonHeader.vue';
import CmsContent from '../components/CmsContent.vue';

export default {
  components: {
    Container,
    ButtonHeader,
    CmsContent,
  },
  data() {
    return {
      content: 'CONTENT',
    };
  },
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 860px;
  text-align: left;
  @include tablet {
    text-align: center;
  }
}

.title {
  margin: 0 0 50px 0;
}
</style>
